<template>
    <div class="animated fadeIn">
  
      <b-card class="card-accent-info">
        <div slot="header">
              Associados
              <div class="card-header-actions">
                
                <b-link href="#" class="card-header-action btn-help">
                  <i class="icon-question" @click="openHelp('/?page=franchise/registration')"></i>
                </b-link>
                
                <!--
                <b-link href="#" class="card-header-action btn-helpvie">
                  <i class="icon-film"></i>
                </b-link>
                -->
              </div>
        </div>

        <b-card-body>
  
          <!--
          <b-row>
            <b-col cols="auto" class="mr-auto">
      
            </b-col>
            <b-col cols="auto" class="">
              <b-form-group>
                <b-button variant="github" class="mr-1 btn-brand" @click="openEditModal(null)"><i class="fa fa-plus"></i><span>Novo Associado</span></b-button>
              </b-form-group>
            </b-col>
          </b-row>
          -->
  
          <b-row>
            <b-col cols="auto">
              <b-form-group>
                  <label for="company" style="font-size: 0.8em">Empresa</label>
                  <b-form-select id="company"
                    v-model="filters.companyId"
                    :plain="true"
                    :options="companyDDL"
                    @change="changeCompany"
                    :value="[null,'c']">
                  </b-form-select>
              </b-form-group>
            </b-col>

            <b-col cols="auto">
              <b-form-group>
                  <label for="status" style="font-size: 0.8em">Grupo</label>
                  <b-form-select id="group"
                    v-model="filters.groupId"
                    :plain="true"
                    :options="selectGroupDDL"
                    :value="[null,'c']"
                    @change="refreshData"
                    >
                  </b-form-select>
              </b-form-group>
            </b-col>

            <b-col cols="auto">
              <b-form-group>
                  <label for="name" style="font-size: 0.8em">Filtro</label>
                  <b-form-input v-model="filters.key" type="text" id="filter" placeholder="Filtro"></b-form-input>
              </b-form-group>
            </b-col>
        
            <b-col cols="auto">
              <b-form-group>
                  <label for="status" style="font-size: 0.8em">Status</label>
                  <b-form-select id="statusId"
                    v-model="filters.statusId"
                    :plain="true"
                    :options="selectGroupUserStatusDDL"
                    :value="[null,'c']">
                  </b-form-select>
              </b-form-group>
            </b-col>

            <!--
            <b-col cols="auto">
              <b-form-group>
                  <label for="status" style="font-size: 0.8em">Status</label>
                  <b-form-select id="status"
                    v-model="filters.status"
                    :plain="true"
                    :options="statusddl"
                    :value="[null,'c']">
                  </b-form-select>
              </b-form-group>
            </b-col>
            -->

            <b-col cols="auto" class="mr-auto" style="padding-top: 12px;">
              <b-form-group>
                <p></p>
                <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="refreshData()"><i class="fa fa-search"></i><span>Localizar</span></b-button>
              </b-form-group>
            </b-col>

            <b-col cols="auto" class="">
              <b-form-group >
                  <label for="perPage">Linhas</label>
                  <b-form-select v-model="perPage" id="perPage"
                    :plain="true"
                    :options="[5,10,20,50]">
                  </b-form-select>
                </b-form-group>
            </b-col>
            
          </b-row>
        
  
            <b-table
                :items="filteredItems"
                :fields="fields"
                :select-mode="selectMode"
                responsive="sm"
                ref="selectableTable"
                :selectable="false"
                :primary-key="primaryKey"
                :tbody-transition-props="transProps"
                sort-icon-left
                @row-clicked="rowClicked"
                :per-page="perPage"
                :current-page="currentPage"
                :busy="isBusy"
                hover
                striped
  
                >
  
                <template #table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Carregando...</strong>
                    </div>
                </template>
                
                <!-- Example scoped slot for select state illustrative purposes -->
                <template #cell(selected)="{ rowSelected }">
                    <template v-if="rowSelected">
                    <span aria-hidden="true">&check;</span>
                    <span class="sr-only">Selected</span>
                    </template>
                    <template v-else>
                    <span aria-hidden="true">&nbsp;</span>
                    <span class="sr-only">Not selected</span>
                    </template>
                </template>
  
                <template #cell(show_details)="row">
                    <b-row>
                        <b-col cols="auto" class="mr-auto">
                            <b-form-group>
                            <b-button size="sm" variant="primary"  @click="row.toggleDetails" class="mr-1 btn-brand"><i class="fa fa-search"></i></b-button>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </template>
                
                <template #row-details="row">
                    <b-card>
                      <b-row>
                            <b-col></b-col>
                            <b-col cols="auto">
                                <button :class="item.button" type="button" @click="openWindow(item.url)" v-for="item in row.item.socialNetworks" :key="item.id">
                                  <i :class="item.icon" />
                                  <span>
                                    {{ item.name }}
                                  </span>
                                </button>                              
                            </b-col>
                            
                        </b-row>
                        <b-row>
                            <b-col class="text-primary small">Serviços:</b-col>
                        </b-row>
                        <b-row>
                            <b-col class="">{{ row.item.services && row.item.services.length > 0 ? row.item.services : "-" }}</b-col>
                        </b-row>

                        <b-row>
                            <b-col class="text-primary small">Público alvo:</b-col>
                        </b-row>
                        <b-row>
                            <b-col class="">{{ row.item.targetAudience && row.item.targetAudience.length > 0 ? row.item.targetAudience : "-" }}</b-col>
                        </b-row>
                    </b-card>
                </template>
                
                <template v-slot:cell(associate)="data">
                    <strong>{{ data.item.user.name }}</strong><br>
                    <div class="container">
                      <div class="row">
                        <div class="col-auto" style="width: 80px">
                          <small>Usuário: </small>
                        </div>
                        <div class="col-sm">
                          {{ data.item.user.username }}
                        </div>                        
                      </div>
                      <div class="row">
                        <div class="col-auto" style="width: 80px">
                          <small>E-mail: </small>
                        </div>
                        <div class="col-sm">
                          {{ data.item.user.email }}
                        </div>                        
                      </div>
                      <div class="row">
                        <div class="col-auto" style="width: 80px">
                          <small>Telefone: </small>
                        </div>
                        <div class="col-sm">
                          {{ data.item.user.phone }}
                        </div>                        
                      </div>
                      <div class="row">
                        <div class="col-auto" style="width: 80px">
                          <small>Grupo: </small>
                        </div>
                        <div class="col-sm">
                          {{ data.item.group.name }}
                        </div>                        
                      </div>
                    </div>

                  </template>

                   
                <template v-slot:cell(companydata)="data">
                   
                   <strong>{{ data.item.companyName }}</strong><br>
                   
                   <div class="container">
                     <div class="row">
                       <div class="col-auto" style="width: 150px">
                         <small>Ramo de Atividade: </small>
                       </div>
                       <div class="col-sm">
                         {{ data.item.activityBranch ? data.item.activityBranch.name : '' }}
                       </div>                        
                     </div>
                     <div class="row">
                       <div class="col-auto" style="width: 150px">
                         <small>Comissão: </small>
                       </div>
                       <div class="col-sm">
                         {{ data.item.comission && data.item.comission > 0 ? data.item.comission + " %" : '' }}
                       </div>                        
                     </div>
                     <div class="row">
                       <div class="col-auto" style="width: 150px">
                         <small>Indicação/Patrocinador: </small>
                       </div>
                         <div class="col-sm">
                         <!-- <i class="fa fa-warning fa-lg mt-4 text-danger" v-show="!(data.item.sponsor && data.item.sponsor.id && data.item.sponsor.id > 0)"></i> -->
                         <span :class="!(data.item.sponsor && data.item.sponsor.id && data.item.sponsor.id > 0) ? 'text-danger' : ''">
                         {{ data.item.sponsor ? data.item.sponsor.name : data.item.sponsorName }}
                        </span>
                       </div>                
                     </div>
                   </div>
                 </template>

                 <template v-slot:cell(registration)="data">
                  <div class="container">
                     <div class="row" v-show="data.item.user.id == $store.state.currentUser.id || accessRegistrationManager">
                       <div class="col-auto" style="width: 100px">
                         <small>Inscrição: </small>
                       </div>
                       <div class="col-sm">
                         {{ $utils.localDate(data.item.createdIn) }}
                       </div>                        
                     </div>
                     <div class="row" v-show="data.item.user.id == $store.state.currentUser.id || accessRegistrationManager">
                       <div class="col-auto" style="width: 100px">
                         <small>Vencimento: </small>
                       </div>
                       <div class="col-sm">
                         {{ data.item.paymentDay }}
                       </div>                        
                     </div>
                     <div class="row" v-show="data.item.user.id == $store.state.currentUser.id || accessRegistrationManager">
                       <div class="col-auto" style="width: 100px">
                         <small>Mensalidade: </small>
                       </div>
                       <div class="col-sm">
                         {{ data.item.paymentDay != null ? '23/01/2024' : '' }}
                       </div>                        
                     </div>
                     <div class="row">
                       <div class="col-auto" style="width: 100px">
                         <small>Indicações: </small>
                       </div>
                       <div class="col-sm">
                         {{ data.item.indication != null ? data.item.indication : 0 }}
                       </div>                        
                     </div>
                   </div>

                </template>

                <template v-slot:cell(action)="data">
                  <b-button size="sm" variant="primary" @click="changePasswordModal(data.item)" class="mr-1 btn-brand" v-show="data.item.user.id == $store.state.currentUser.id || accessRegistrationManager"><i class="fa fa-lock" alt="Alterar senha" title="Alterar senha"></i></b-button>
                  <b-button size="sm" variant="primary" @click="changeChangeGroupModal(data.item)" class="mr-1 btn-brand" v-show="accessRegistrationManager && data.item.group.isRegistration"><i class="fa fa-share-alt" alt="Alterar gupo do associado" title="Alterar grupo do associado"></i></b-button>
                </template>


                <template v-slot:cell(st)="data">
                    <c-switch class="" @change.native="changeStatus(data.item)" color="primary" :checked="data.item.st=='A'" label variant="pill" v-bind="switchLabelIcon" /> 
                </template>
                
                <template v-slot:cell(ispublic)="data">
                    <c-switch class="" color="primary" :checked="data.item.ispublic==1" label variant="pill" v-bind="switchLabelIcon" /> 
                </template>
                
            </b-table>
            <nav>
                <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Anterior" next-text="Próximo" />
            </nav>
  
  
        </b-card-body>
     </b-card>
  
  
     <b-modal
              v-model="editModal"
              id="edit-modal"
              centered
              hide-footer
              title="Associado"
              size="lg">
              <registration-user-component :item="selectedItem" :isManager="accessRegistrationManager" @resp="handleResp"></registration-user-component>
      </b-modal>

      <b-modal
              v-model="passwordModal"
              id="password-modal"
              centered
              hide-footer
              title="Alterar Senha do Usuário"
              size="lg"
              >
              <change-user-password-component :selectedItem="selectedItem.user" @resp="handleRespChangePassword"></change-user-password-component>
      </b-modal>

      <b-modal
              v-model="changeGroupModal"
              id="change-group-modal"
              centered
              hide-footer
              title="Alterar Grupo do Associado"
              size="md"
              >
              <registration-group-change-component :selectedItem="selectedItem" :groupDDL="groupDDL" @response="handleChangeGroup"></registration-group-change-component>
      </b-modal>
  
    </div>
  
  </template>
  
  <script>
  import Vue from 'vue'
  import axios from "axios";
  import ChangeUserPasswordComponent from '../sys/ChangeUserPasswordComponent';
  import RegistrationGroupChangeComponent from './RegistrationGroupChangeComponent';
  import RegistrationUserComponent from './RegistrationUserComponent';

  import { Switch as cSwitch } from '@coreui/vue'
  
  /* Toast */
  import VueNotifications from 'vue-notifications'
  import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
  //import { table } from 'console'
  
  const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
  }
  
  miniToastr.init({types: toastTypes})
  
  function toast ({title, message, type, timeout, cb}) {
    return miniToastr[type](message, title, timeout, cb)
  }
  
  const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
  }
  VueNotifications.setPluginOptions(options)
  
  Vue.use(VueNotifications, options)
  /* Toast - End */
  
  const newItem = {id: null, name: '', description: '', st: 'A', _rowVariant: ''}
  
  export default {
    name: 'tables',
    components: {
      Event,
      cSwitch,
      ChangeUserPasswordComponent,
      RegistrationGroupChangeComponent,
      RegistrationUserComponent
    },
    data: () => {
      return {
        accessRegistrationManager: false,

        passwordModal: false,
        changeGroupModal: false,
  
        groupDDL: [],
        groupUserStatusDDL: [],

        statusddl: [
          {
            text: '- Todos -',
            value: 0
          },
          {
            text: 'Ativo',
            value: 'A'
          },
          {
            text: 'Inativo',
            value: 'I'
          }
        ],
        companyDDL: [],

        isBusy: false,
        currentPage: 1,
        switchLabelIcon: {
            dataOn: '\u2713',
            dataOff: '\u2715'
        },
        switchLabelTxt: {
            dataOn: 'yes',
            dataOff: 'no'
        },
  
        tableRef: "table",
        tableSelectable: false,
        errorMessage: '',
        editModal: false,
        filters: {
          companyId: null,
          groupId: 0,
          key: '',
          status: 0,
          statusId: 0
        },
  
        modes: ['multi', 'single', 'range'],
        selectMode: 'single',
        selected: [],
        transProps: {
          // Transition name
          name: 'flip-list'
        },
        primaryKey: "id",
  
        selectedItem: newItem,
        items: [        
        ],
        fields: [
          {key: 'show_details', label: "", thStyle: { width: "40px" } },
          //{key: 'id' },
          //{key: 'costcenter', label: 'Centro de Custo', sortable: true, thStyle: { width: "200px" }  },
          {key: 'associate', label: 'Associado', sortable: false },
          {key: 'companydata', label: 'Empresa', sortable: false },
          {key: 'registration', label: 'Informações do Associado', sortable: false },
          //{key: 'meetingTime', label: 'Hora', sortable: true, class: 'text-center', thStyle: { width: "100px" } },
          //{key: 'memberCount', label: 'Membros', sortable: true, class: 'text-center', thStyle: { width: "80px" } },
          //{key: 'dueDate', label: 'Data', sortable: true, class: 'text-center', thStyle: { width: "150px" }},
          //{key: 'originalValue', label: 'Valor', sortable: true, class: 'text-right', thStyle: { width: "150px" }},
          //{key: 'paymentValue', label: 'Valor Pago', sortable: true, class: 'text-right', thStyle: { width: "150px" } },
          //{key: 'description', label: 'Descrição', sortable: false },
          //{key: 'serviceTotal', label: 'Serviços', sortable: false, thStyle: { width: "40px" } },
          //{key: 'statusName', label: 'Status', sortable: true, class: 'text-center', thStyle: { width: "150px" } }
          //{key: 'st', label: 'Status', sortable: true, thStyle: { width: "40px" } },
          {key: 'action', label: '', sortable: false, thStyle: { width: "100px" }, tdClass: 'align-middle' },
        ],
        
        filterable: ['username'],
        sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
        perPage: 20
      }
    },
    computed: {
      selectGroupUserStatusDDL: function() {
        var list = [...this.groupUserStatusDDL]
        list = list.sort((a,b) => (a.text > b.text) ? 1 : -1)
        list.unshift({ value: '0' , text: '- Todos -' })
        return list
      },
      selectGroupDDL: function() {
        var list = [...this.groupDDL]
        list = list.sort((a,b) => (a.text > b.text) ? 1 : -1)
        list.unshift({ value: '0' , text: '- Todos -' })
        return list
      },
      totalRows: function () { return this.getRowCount() },
      filteredItems() {
        try {
            return this.items.filter(item => {

              if(item.statusId == 2)
                item._rowVariant = 'danger'
              else
              if(item.statusId == 1)
                item._rowVariant = 'warning'

              return (this.filters.key == '' || (
                  this.$utils.filterString(item.user.name, this.filters.key)
                  || this.$utils.filterString(item.companyName, this.filters.key)
                  //(item.name != null && item.name.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
                  //|| (item.username != null && item.username.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
                  //|| (item.email != null && item.email.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
                  ))
                  && (this.filters.status==0 || (this.filters.status == 'A' || this.filters.status == 'I') && item.st == this.filters.status )                 
                  && (this.filters.statusId==0 || item.statusId == this.filters.statusId )
            })
        }
        catch(e) {
            return this.items;
        }
      }
    },
    methods: {

      getRowCount: function () {
        if(this.items)
            return this.items.length
        else
            return 0;
      },
     

      changeStatus(item) {
        if(item != null) {
          if(item.st == 'A') 
            item.st = 'I'; 
          else 
            item.st = 'A';
          this.saveItem(item);
        }
      },

      async saveItem(currentItem) {

        var s = this;
        var postData = {...currentItem};

        postData["companyId"] = s.filters.companyId
        postData["uid"] = this.$store.state.currentUser.id,
        postData["sid"] = this.$store.state.currentUser.sid

        await axios.post(
            this.$store.state.ws_url + "/franchise/group",
            postData
        ).then(function() {
            s.closeEditModal()
            s.refreshData();
        }
        ).catch(function (error) {
            console.log(error);

            toast ({
                type: VueNotifications.types.warn,
                title: 'Grupo',
                message: error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Sem permissão de acesso.',
                timeout: 5000
            })        
        });

    },

    save() {

        let msgError = [];

        if(this.selectedItem.name.length <= 2)
            msgError.push("Sigla");
        
        if(msgError.length > 0) {
            let msgErrorExt = "Verifique os campos: ";
            let msgErrorSep = "";
            msgError.forEach(function(element) { msgErrorExt += msgErrorSep + element; msgErrorSep=", "; } )

            toast ({
                type: VueNotifications.types.error,
                title: 'Grupo',
                message: msgErrorExt,
                timeout: 5000
            })
        }
        else {
            this.saveItem(this.selectedItem);
        }
    },

      enableDisable() {
        console.log('Habilitando/desabilitando modelo')
      },
      closeEditModal() {
        this.editModal = false;
      },
      openEditModal(item) {
        if(item == null) {
            this.selectedItem = { ...newItem };      
        }
        else {
            this.selectedItem = { ...item };
        }
        this.editModal = true;
      },
      onRowSelected(items) {
        this.selected = items       
      },
      selectAllRows() {
        this.$refs.selectableTable.selectAllRows();
      },
      clearSelectedRows() {
        this.$refs.selectableTable.clearSelected();
      },
      rowClicked(item) {
            this.openEditModal(item);
      },
      getBadge (status) {
        return status === 'A' ? 'primary'
            : status === 'I' ? 'danger'
            : status === 'Pending' ? 'warning'
                : status === 'Banned' ? 'danger' : 'primary'
      },

      async getGroupDDL() {
          var s = this;
          var currentUser = this.$store.state.currentUser;
         
          var url = this.$store.state.ws_url + "/franchise/group/ddl?companyId=" + s.filters.companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
          if(!this.accessRegistrationManager)
            url = this.$store.state.ws_url + "/franchise/group/ddl?companyId=" + s.filters.companyId + "&isGroup=1&uid=" + currentUser.id + "&sid=" + currentUser.sid

          await axios.get(
              url
          ).then(function (resp) {
              s.groupDDL = resp.data.obj;
          }
          ).catch(function (error) {
              console.log(error.message);            
          });
      },

      
      async getGroupUserStatuDDL() {
          var s = this;
          var currentUser = this.$store.state.currentUser;
         
          await axios.get(
              this.$store.state.ws_url + "/franchise/group/user/status/ddl?uid=" + currentUser.id + "&sid=" + currentUser.sid
          ).then(function (resp) {
              s.groupUserStatusDDL = resp.data.obj;
          }
          ).catch(function (error) {
              console.log(error.message);            
          });
      },


      async refreshData() {
        try {
            var s = this;
            var currentUser = this.$store.state.currentUser;
            this.isBusy = true;

            await axios.get(
                this.$store.state.ws_url + "/franchise/group/user?companyId=" + s.filters.companyId + "&groupId=" + s.filters.groupId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
            ).then(function (resp) {
                s.items = resp.data.obj;
            }
            ).catch(function (error) {
                console.log("ERRO")
                console.log(error.message);
                toast ({
                    type: VueNotifications.types.error,
                    title: 'Associados',
                    message: 'Sem permissão de acesso. Verifique e tente novamente.',
                    timeout: 3000
                })
            });

            this.isBusy = false;
        } catch (e) {
            console.log(e)
        }
      },
      changeCompany() {
        this.getGroupDDL()
        this.refreshData()
      },

      handleRespChangePassword(obj) {
        this.passwordModal = false
        toast ({
            type: VueNotifications.types.success,
            title: 'Alteração de Senha',
            message: 'Senha alterada com sucesso.',
            timeout: 3000
        })
      },

      changePasswordModal(item) {
        this.selectedItem = item
        this.passwordModal = true;
      },
      changeChangeGroupModal(item) {
        this.selectedItem = item
        this.changeGroupModal = true;
      },
      
      handleChangeGroup(obj) {
        this.changeGroupModal=false
        this.refreshData()
      },

      handleResp(obj) {
        this.editModal=false
        this.refreshData()
      },

      async getAccessRegistrationManager() {
            var s = this
            var currentUser = this.$store.state.currentUser

            await axios.get(
                this.$store.state.ws_url + "/user/checkaccess?uid=" + currentUser.id + "&sid=" + currentUser.sid + "&accessCode=FRN_REGISTRATION_MGR"
            ).then(function(resp) {
              s.accessRegistrationManager = true
              s.getGroupDDL()
            })
            .catch(function(error) {
              s.accessRegistrationManager = false
              s.getGroupDDL()
            })
          
        },
        openWindow(url) {          
          window.open(url, '_blank')
        },

        openHelp(url) {
          window.open(this.$store.state.config.ws_help + url, '_blank')
        }
    },
    mounted: function() {
      this.companyDDL = this.$store.state.currentUser.companies
      this.filters.companyId = this.$store.state.currentUser.companyId
      this.filters.groupId = 0
      this.getAccessRegistrationManager()
      this.getGroupUserStatuDDL()
      this.refreshData()
    }
  }
  </script>
  
  <style scoped>
  table#table-transition-example .flip-list-move {
  transition: transform 1s;
  }
  </style>